import React, { useEffect, useState } from 'react';
import { Map, OrderedMap } from 'immutable';
import { connect } from 'react-redux';
import * as instrumentActions from '../../instruments/actions/instrument.actions';
import { ReduxState } from '../../types';
import Loader from '../../frontend-common-libs/src/components/common/Loader';
import './styles/instrument-fleet.scss';
import { Toggle } from '../../frontend-common-libs/src/components/common/radio_button_group';
import {
  FleetToggleOptions,
  FleetToggleOptionsEnum
} from '../../conventional-pcr-frontend/fleet-management/fleet-management/FleetManagementOptions';
import { getSelectedProjectId } from '../../project-management';
import { InstrumentFamilyPluginRepository } from '../../instrument-family-plugin';

export type Props = {
  isLoading: boolean;
  instruments: OrderedMap<string, Map<string, any>>;
  statuses: Map<string, Map<string, any>>;
  errorMessage: string;
  loadInstrumentListIfNeeded: typeof instrumentActions.loadInstrumentListIfNeeded;
  projectId: string;
};

export function FleetImpl(props: Props) {
  const [toggleCheckedValue, setToggleCheckedValue] = useState<string>(
    FleetToggleOptionsEnum.Create
  );

  useEffect(() => {
    const { instruments, loadInstrumentListIfNeeded } = props;
    if (!instruments.size) {
      loadInstrumentListIfNeeded();
    }
  }, []);

  const { instruments, isLoading, errorMessage, loadInstrumentListIfNeeded, statuses, projectId } =
    props;

  if (isLoading) {
    return <Loader />;
  }

  const onUpdateFleetToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    setToggleCheckedValue(e.currentTarget.value);
  };

  const updateFleetToggleCallback = (toggleValue: string) => {
    setToggleCheckedValue(toggleValue);
  };

  const renderFleetManagementPlugin = () => {
    const plugin =
      InstrumentFamilyPluginRepository.getInstance().getPluginByInstrumentType('PTCTempo');
    if (plugin) {
      const FleetManagement = plugin.getFleetManagement();

      return (
        <FleetManagement
          instruments={instruments}
          projectId={projectId}
          selectedFleetToggle={toggleCheckedValue}
          setFleetToggleCallback={updateFleetToggleCallback}
          statuses={statuses}
          fetchMoreData={loadInstrumentListIfNeeded}
          isLoading={isLoading}
          isError={!!errorMessage}
        />
      );
    }

    return null;
  };

  return (
    <div id="instrument-fleet">
      <span id="fleet-page-subtitle" className="fleet-management-header">
        Instrument Reservation and Control
      </span>
      <Toggle
        id="fleet-instrument-toggle-options"
        name="fleet-instrument-toggle"
        onChange={onUpdateFleetToggle}
        options={FleetToggleOptions}
        checkedValue={toggleCheckedValue}
      />
      <hr />
      {renderFleetManagementPlugin()}
    </div>
  );
}

function mapStateToProps(state: ReduxState) {
  return {
    isLoading: state.instruments.get('isLoading'),
    projectId: getSelectedProjectId(state),
    instruments: state.instruments.get('instruments'),
    errorMessage: state.instruments.get('error'),
    statuses: state.instruments.get('statuses')
  };
}

export default connect(mapStateToProps, {
  loadInstrumentListIfNeeded: instrumentActions.loadInstrumentListIfNeeded
  // @ts-ignore
})(FleetImpl);
